<script lang="ts">
    export let size = "1rem"
    export let width = size
    export let height = size
    export let color = "currentColor"
    export let viewBox = "0 0 24 24"
    export let path: string
    export let props: any = {}
</script>

{#if path}
    <svg {width} {height} {viewBox}>
        <path {...props} d="{path}" fill="{color}"></path>
    </svg>
{/if}
